import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function create(data) {
  const response = await http
    .postData("/informed-consent-tindakan", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id, data) {
  const response = await http
    .putData(`/informed-consent-tindakan/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/informed-consent-tindakan`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/informed-consent-tindakan/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getTemplate(jenisForm: string) {
  const response = await http
    .getData(`/informed-consent-tindakan/template/${jenisForm}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function finalize(id: number) {
  const response = await http
    .putData(`/informed-consent-tindakan/${id}/finalize`, {})
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/informed-consent-tindakan/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

function print(id) {
  window.open(
    `${http.getAPI()}/informed-consent-tindakan/${id}/pdf`,
    "_blank"
  );
}

export default {
  create,
  update,
  getByRegister,
  find,
  getTemplate,
  finalize,
  destroy,
  print
};
